import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { device } from '../../../utils/helpers'

const TabItem = styled.li`
  color: ${props => props.isActive ? '#fca317' : '#4d4d4d'};
  padding-right: 10px;
  padding-bottom: 1rem;

  @media ${device.mobileMinM} {
    padding-right: 15px;
  }

  @media ${device.mobileMinL} {
    padding-right: 30px;
  }

  @media ${device.tablet} {
    padding-bottom: 0.8333333333333334vw;
    padding-right: 2.34375vw;
  }
`

const TabLink = styled.a`
  font-size: 16px;
  font-family: 'BarlowExtraBold';
  cursor: pointer;
  text-transform: uppercase;

  @media ${device.laptop} {
    font-size: 18px;
  }

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const Tab = ({ tabIndex, title, onClick, isActive, handleSlideChange }) => (
  <TabItem isActive={isActive}>
    <TabLink
      onClick={(event) => {
        event.preventDefault()
        onClick(tabIndex)
        handleSlideChange && handleSlideChange()
      }}
    >
      {title}
    </TabLink>
  </TabItem>
)

Tab.propTypes = {
  /**
   * Onclick functon
   */
  onClick: PropTypes.func,
  /**
   * Index of the tab
   */
  tabIndex: PropTypes.number,
  /**
   * The active tab
   */
  isActive: PropTypes.bool
}

export default Tab



// WEBPACK FOOTER //
// ./src/components/UI/Tabs/Tab.js